import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { CounterDirections } from "@utils/enums";
import { CounterTheme } from "@utils/enums";

import * as BoxCountModule from "@redux/modules/api/data/boxCount/boxCount.module";
import * as BoxCountSelectors from "@redux/modules/api/data/boxCount/boxCount.selectors";

import BoxCounter from "./boxCounter.component";
import { TextSize } from "./boxCounter.config";
import { useThunkDispatch } from "@redux/dispatcher";

type Props = {
    sku: string;
    maxValue: string;
    direction: string;
    textSize: TextSize;
    theme: CounterTheme;
};

const BoxCounterContainer = ({
    sku,
    maxValue,
    direction,
    textSize,
    theme = CounterTheme.DARK,
}: Props) => {
    const boxCount = useSelector(BoxCountSelectors.getBoxCount(sku));
    const dispatch = useThunkDispatch();

    const startingValue =
        direction === CounterDirections.DOWN ? parseInt(maxValue) : 0;
    let value = !isNaN(Number(boxCount)) ? Number(boxCount) : startingValue;

    const startPolling = () => {
        setInterval(() => dispatch(BoxCountModule.load(sku, true)), 30000);
    };

    useEffect(() => {
        if (sku) {
            dispatch(BoxCountModule.load(sku, true));
            startPolling();
        }
    }, [sku]);

    return (
        <BoxCounter
            length={maxValue.length}
            currentValue={value}
            textSize={textSize}
            theme={theme}
        />
    );
};

export { BoxCounterContainer };
